import React from 'react';
import "./Countingsection.css";
import onlineOrderImage from "../images/delivery.png";
import takeawayImage from "../images/takeaway.png";
import cateringImage from "../images/catering.png";
import { Link } from 'react-router-dom';

const Countingsection = () => {
  return (
    <div className='countingsection-part'>
      {/* Left Section */}
      <div className='countingsectionpart-1'>
        <h1 className='countingsection-text'>
          Bringing Top-Notch Indian Grub to Scousers Far and Wide
        </h1>
        <Link to="./menu">
          <button className='countingsection-haveatalk'>Check Out The Menu</button>
        </Link>
      </div>

      {/* Right Section */}
      <div className='countingsectionpart-2'>
        {/* Online Orders Section */}
        <div className='countingsection-count-section'>
          <div className='countingsection-count-box'>
            <h1 className='countingsection-countbox-text'>
              <strong className='count-strong'>500+</strong><br /> Orders Smashed Out Online
            </h1>
          </div>
          <div className='countingsection-count-box-image'>
            <img src={onlineOrderImage} alt='Online Orders' className='countingsection-count-box-image-i' />
          </div>
        </div>

        {/* Takeaway Section */}
        <div className='countingsection-count-section'>
          <div className='countingsection-count-box-image'>
            <img src={takeawayImage} alt='Takeaway Service' className='countingsection-count-box-image-i' />
          </div>
          <div className='countingsection-count-box'>
            <h1 className='countingsection-countbox-text'>
              <strong className='count-strong'>900+</strong><br /> Takeaways Bagged and Tagged
            </h1>
          </div>
        </div>

        {/* Catering Section */}
        <div className='countingsection-count-section'>
          <div className='countingsection-count-box'>
            <h1 className='countingsection-countbox-text'>
              <strong className='count-strong'>110+</strong><br /> Bashes Catered Like a Boss
            </h1>
          </div>
          <div className='countingsection-count-box-image'>
            <img src={cateringImage} alt='Catering Service' className='countingsection-count-box-image-i' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Countingsection;
